import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/PostForm.css';

const PostForm = ({ onSubmit }) => {
  const { t } = useTranslation();
  const [content, setContent] = useState('');
  const [visibility, setVisibility] = useState('public');
  const [imagePreviews, setImagePreviews] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const previews = files.map(file => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setImagePreviews(prev => [...prev, ...previews]);
  };

  const removeImage = (index) => {
    setImagePreviews(prev => {
      const newPreviews = [...prev];
      URL.revokeObjectURL(newPreviews[index].preview);
      newPreviews.splice(index, 1);
      return newPreviews;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (content.trim() || imagePreviews.length > 0) {
      setSubmitting(true);
      
      // Handle files upload
      const formData = new FormData();
      formData.append('content', content);
      formData.append('visibility', visibility);
      
      // Add image if present (only first one for now)
      if (imagePreviews.length > 0) {
        formData.append('image', imagePreviews[0].file);
      }

      await onSubmit(formData);
      setContent('');
      setVisibility('public');
      setImagePreviews([]);
      setSubmitting(false);
      
      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  return (
    <form className="post-form" onSubmit={handleSubmit}>
      <textarea
        placeholder={t('home.whatNew')}
        value={content}
        onChange={(e) => setContent(e.target.value)}
      />
      
      {imagePreviews.length > 0 && (
        <div className="image-previews">
          {imagePreviews.map((img, index) => (
            <div key={index} className="image-preview">
              <img src={img.preview} alt={`Preview ${index + 1}`} />
              <button
                type="button"
                className="remove-image-btn"
                onClick={() => removeImage(index)}
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      )}
      
      <div className="post-form-footer">
        <div className="post-form-actions">
          <label className="file-upload-btn" title="Добавить фото">
            📷
            <input
              ref={fileInputRef}
              type="file"
              multiple
              accept="image/*,video/*"
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
          </label>
        </div>

        <div className="post-form-right">
          <select
            className="visibility-select"
            value={visibility}
            onChange={(e) => setVisibility(e.target.value)}
          >
            <option value="public">🌐 Public</option>
            <option value="followers">👥 Followers Only</option>
            <option value="private">🔒 Private</option>
          </select>
          
          <button 
            type="submit" 
            disabled={submitting || (!content.trim() && imagePreviews.length === 0)}
          >
            {submitting ? 'Posting...' : t('home.post')}
          </button>
        </div>
      </div>
    </form>
  );
};

export default PostForm;
